import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PrimeReactProvider } from "primereact/api";
import { PersistGate } from "redux-persist/integration/react";
import "./index.scss";
import { store, persistor } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import GAProvider from "./analytics/GAProvider";

const primeReactConfig = {
  hideOverlaysOnDocumentScrolling: true,
};

const browserRouterFuture = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <PrimeReactProvider value={primeReactConfig}>
    <BrowserRouter future={browserRouterFuture}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <GAProvider>
            <App />
          </GAProvider>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </PrimeReactProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
